module.exports = __webpack_public_path__ + "assets/img/title-1bb8cce2.png";